import * as Yup from 'yup';

export const changePasswordSchema = (adminOperation = false) =>
  Yup.object().shape({
    oldPassword: adminOperation
      ? Yup.string()
      : Yup.string()
          .min(8, 'A senha atual deve ter pelo menos 8 caracreres')
          .required('A senha atual é obrigatória'),
    newPassword: (adminOperation
      ? Yup.string()
      : Yup.string().notOneOf(
          [Yup.ref('oldPassword')],
          'A nova senha deve ser diferente da senha atual'
        )
    )
      .min(8, 'A senha deve ter pelo menos 8 caracteres')
      .required('Senha é obrigatória'),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'A senha precisa ser igual')
      .required('A confirmação de senha é obrigatória'),
  });
